import moment from 'moment';

/**
 * Ready-made mask/validate/placeholder bundles for common patterns.
 * Spread into MaskedInput: `<MaskedInput {...MASK_PRESETS.dateMDY} value={...} onValueChange={...} />`
 */
export const MASK_PRESETS = {
	dateMDY: {
		mask: '99/99/9999',
		placeholder: 'MM/DD/YYYY',
		// Typing any of these after a single-digit month/day zero-pads it: `1/2/2000` → `01/02/2000`.
		separators: ['/', '-', '.'],
		validate: (value: string) => moment(value, 'MM/DD/YYYY', true).isValid(),
	},
	phoneUS: {
		mask: '(999) 999-9999',
		placeholder: '(555) 555-5555',
	},
} as const;
